/* Built In Imports */
/* External Imports */
import axios from 'axios';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';

let isCache = false;
const API_PREFIX = '/content/fetchiso';

export const fetchDetails = async (region, lang, slug = ``) => {
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: slug
          ? `events/${slug}`
          : `events/special-events/sadhguru-sannidhi`,
        region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchSannidhiGeoContentData = async () => {
  const resp = await axios({
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    url: config.SANNIDHI_PROGRAM_API,
  });
  console.log('data', resp.data);
  return resp?.data;
};


